import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './packages/auth-client';
import { PermissionProvider } from './packages/permission-guard';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LandingResolver } from './components/LandingResolver';
import { Layout } from './components/Layout';
import { publicRoutes } from './routes/publicRoutes';
import { workspaceRoutes } from './routes/workspaceRoutes';
import { projectRoutes } from './routes/projectRoutes';
import { platformRoutes } from './routes/platformRoutes';

/**
 * The whole route tree, without providers or a router — App wraps it in
 * BrowserRouter, and the route-contract test renders it in a MemoryRouter.
 */
export function AppRoutes() {
    return (
        <Routes>
            {/* Public */}
            {publicRoutes}

            {/* Protected */}
            <Route element={<ProtectedRoute />}>
                {/* Post-login resolver — sends restricted users to their
                    project, everyone else to the dashboard. No Layout so
                    the sidebar doesn't flash before the redirect. */}
                <Route path="/home" element={<LandingResolver />} />
                <Route element={<Layout />}>
                    {workspaceRoutes}
                    {projectRoutes}
                </Route>
                {/* The platform console has its own shell (PlatformLayout). */}
                {platformRoutes}
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <PermissionProvider>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
            </PermissionProvider>
        </AuthProvider>
    );
}
